<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for">Foreword by Robert E. Coleman</a></p>
<p class="Toc1" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">Introduction to Gospel Witness</span></a></p>
<p class="Toc" id="ch-002"><a href="#/xhtml/chapter002#ch002">2.<span class="space1">God’s Mission and Evangelism</span></a></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Gospel Clarity</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Always Ready</span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Engaging Relationships</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">Witness in Word and Deed</span></span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">Conversion to Christ-Follower</span></span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Gospel Praxis in a Pluralistic Society</span></span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">Witness through Community</span></span></p>
<p class="Toc" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">10.<span class="space05">Baptism and Discipleship</span></span></p>
<p class="Toc" id="ch-011"><span href="#/xhtml/chapter011#ch011" title="Link target outside of Sample">11.<span class="space05">Shaping a Gospel-Sharing Church</span></span></p>
<p class="Toc" id="ch-012"><span href="#/xhtml/chapter012#ch012" title="Link target outside of Sample">12.<span class="space05">Sending Disciples on Mission</span></span></p>
<p class="Toc1a" id="epi"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue: Faithful Presence and Urgency</span></p>
<p class="Toc1" id="app"><span href="#/xhtml/appendix#app" title="Link target outside of Sample">Appendix: God’s Human Drama Illustrated</span></p>
<p class="Toc1" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3237b0c6